<ion-header class="ion-no-shadow ion-no-border">
    <header-notifications></header-notifications>
    <ion-toolbar class="ion-hide-xl-up">
        <ion-title class="full">{{ 'KEYWORDS_PAGE_TITLE' | trns }}</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">

    <app-out-link class="bottom-space"></app-out-link>

    <div [ngClass]="{'hidden': loading}"
         class="content-box">

        <div class="content-box-inner">
            <div class="content-data">
                <keyword-settings [view]="view"
                                  [loadEvent]="true"
                                  (onShowManageKeywords)="changeView('manage-keywords')"
                                  (onShowInterests)="changeView('matching')"
                                  (onShowAttendeeList)="showAttendeeList()"
                                  (onChangeLoading)="changeLoading($event)"
                                  (onShowAttendeeDetail)="showAttendeeDetail($event)">
                </keyword-settings>
            </div>
        </div>
    </div>
    <ng-container *ngIf="loading">
        <div class="content-centered-column">
            <div class="content-centered-row">
                <ion-spinner></ion-spinner>
            </div>
        </div>
    </ng-container>
</ion-content>